import { Injectable, inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { PreviewImplementation } from '@commoncore/implementation/PreviewImplementation';
import { GlobalService } from '@commoncore/services/global.service';
import { HomeController } from '@mainrepo/app/core/controller/HomeController';
import { FileOperationsController } from '../controller/FileOperationsController';
import { LocalStorageSvc } from '../services/localStorage.service';

@Injectable({
  providedIn: 'root'
})


class  SummaryService {

  homeImplementation:any;
  universalService:any;
  folderService:any;
  router:any
  homeController;
  fileOpsController:FileOperationsController;
  route:any;
  localStorageSvc: LocalStorageSvc;
  rootFolderKey: string;
  userloginController:any
  shareAccessService:any;
  recoverFactor:boolean = false;
  contextMenuService:any;
  sessionStorageSvc: any;

  constructor(public globalService:GlobalService){
    this.homeController = HomeController.getInstance(this.globalService);
    this.fileOpsController = FileOperationsController.getInstance(globalService);
    this.homeController.setEnvObjects(this.globalService)
    this.universalService = this.globalService.getUniversalServiceRef();
    this.folderService = globalService.getFolderServiceRef();
    this.router = globalService.getRouterRef();
    this.route = globalService.getActivatedRoute();
    this.localStorageSvc = globalService.getLocalStorageSvcRef();
    this.sessionStorageSvc = globalService.getSessionStorageSvcRef();
    this.userloginController= UserloginController.getInstance(this.globalService);
    this.userloginController.setEnvObjects(this.globalService)
    this.shareAccessService  = globalService.getShareAccessServiceRef();
    this.contextMenuService = globalService.getContextMenuServiceRef();
  }

  canActivate(next): Promise<boolean> | boolean {
      this.universalService.emptyShared = false;
      this.shareAccessService.isSharedFilesView = false;
      let userData = this.localStorageSvc.getUserData(true)
      this.rootFolderKey = userData["rootFolderKey"];
      this.recoverFactor = this.localStorageSvc.getRecoverData(false) == "true"?true:false;
      var previewImpl = PreviewImplementation.getInstance(this.globalService)
      if(this.universalService.showPreview && !this.universalService.showViewButton){
        this.universalService.showPreview = false;
        previewImpl.closePreview();
        return false;
      }else if (next.data.page == "about" || next.data.page == "pricing" || next.data.page == "features" || next.data.page == "signin"){
        return true;
      }
      this.universalService.showPreview = false;
      return this.refreshToken(next);
    }
    
    async refreshToken(next){
      let userData = this.localStorageSvc.getUserData(true)
      if(this.recoverFactor){
        //if(this.localStorageSvc.isStaySigned() == "true"){
        if(userData["isStaySignIn"] == true){
          await this.userloginController.refreshData(true,false,false);
          if(  this.localStorageSvc.getUserData() == null || 
            this.localStorageSvc.getUserData() ==undefined){
              this.universalService.disableModalBackdrop();
            this.router.navigate(['/']);
            return false
          }else{
            this.router.navigate(['/']);
            return false
          }
        }else{
          this.router.navigate(['/']);
          return false
        }
       
      } else if (userData["isStaySignIn"] && this.universalService.refreshTokenInprocess) {//else if (this.localStorageSvc.isStaySigned() && this.universalService.refreshTokenInprocess) {
        
        await this.userloginController.refreshData(true,false,false);
       if(  this.localStorageSvc.getUserData() == null || 
         this.localStorageSvc.getUserData() ==undefined){
           this.universalService.disableModalBackdrop();
         this.router.navigate(['/']);
         return false
       }else{
          return this.fetchSummary(next);
       }
     }else{
           return this.fetchSummary(next);
      } 

    }


    async fetchSummary(next):Promise<boolean>{
     // this.universalService.showLoader = true;
      this.universalService.showCreateFolderAndUploadButtons = true;      
      try {
        if(next.params){
           
          if(next.params["folderKey"]){
            this.sessionStorageSvc.setCurrentFolderKey(next.params["folderKey"], true)
          }else if(next.params["privateFolderObjectKey"]){
            this.sessionStorageSvc.setCurrentPrivateFolderKey(next.params["privateFolderObjectKey"], true)
          }
        }

        // if(next.routeConfig.path.includes('allfiles') || this.universalService.currentTab == "" || this.universalService.currentTab == "PrivateFolder" || next.data["tab"] == 'privatefolder'){
        //   await this.homeController.fetchSummary(next.data["tab"] ? next.data["tab"] : '');
        // } else {
        //   await this.fileOpsController.updateSummaryCounts(this.universalService.currentTab);
        // }
      
        // if(this.universalService.isServerError){
          // this.router.navigate(['/'], { queryParams: next.queryParams });
        // }
        return Promise.resolve(true)
        }
  
      catch(exc){
        console.log("exc", exc)
        // this.universalService.isServerError = true;
        // if(this.universalService.isServerError){
        //   this.router.navigate(['/'], { queryParams: next.queryParams });
        // }
        return Promise.resolve(true);
      }
          
    }
  
  
}

export const SummaryGuard: CanActivateFn =
    (route, state) => {
      return inject(SummaryService).canActivate(route);
    }

